import React from 'react'
import { Link } from "react-router-dom";


const HomeAbout = () => {
    return (
        <>

            {/* <div className="modal fade" id="searchModal" tabIndex={-1} aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-fullscreen">
                    <div className="modal-content rounded-0">
                        <div className="modal-header">
                            <h4 className="modal-title text-secondary mb-0" id="exampleModalLabel">Search by keyword</h4>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
                        </div>
                        <div className="modal-body d-flex align-items-center">
                            <div className="input-group w-75 mx-auto d-flex">
                                <input type="search" className="form-control p-3" placeholder="keywords" aria-describedby="search-icon-1" />
                                <span id="search-icon-1" className="input-group-text p-3"><i className="fa fa-search" /></span>
                            </div>
                        </div>
                    </div>
                </div>
            </div> */}
            <div style={{ overflow: "hidden" }}>

                <div className="container-fluid py-5" style={{ marginTop: "-60px" }}>
                    <div className="container py-5">
                        <div className="row g-5">

                            <div className="col-xl-7 wow fadeInRight" data-wow-delay="0.3s">
                                <h5 className="sub-title pe-3">About the Shiv Travels</h5>
                                {/* <h1 className="display-5 mb-4">We’re Trusted Immigration Consultant Agency.</h1> */}
                                <p className="mb-4" style={{ color: "black" }}>In Satna, we at Shiv Travels Taxi Services provide dependable and reasonably priced cabs. Our goal has always been to offer comfortable and safe transportation. We can assist you whether you need a transportation for a round-trip or one-way travel, local hourly use, or an airport transfer.</p>
                                <p className="mb-4" style={{ color: "black" }}>At the best price, you may reserve our Kia Sonet, Dzire, Ertiga, Innova Crysta, and more. The proprietor, Neelendra Kumar Shiv. For reservations or questions, please get in touch with us directly! Give <a href="tel:+91 7389578180" style={{ color: "black" }}> +91-7389578180</a> a call.</p>
                                <div className="row gy-4 align-items-center">
                                    {/* <div className="col-12 col-sm-6 d-flex align-items-center">
                                    <i className="fas fa-map-marked-alt fa-3x text-secondary" />
                                    <h5 className="ms-4">Best Immigration Resources</h5>
                                </div> */}
                                    <div className="col-12 col-sm-12 d-flex align-items-center">
                                        <i className="fas fa-passport fa-3x text-secondary" />
                                        <h5 className="ms-4">Why Choose Us ?</h5>
                                    </div>
                                    <div className="col-4 col-md-3" style={{ marginTop: "-80px" }}>
                                        <div className="bg-light text-center rounded p-3">
                                            {/* <div className="mb-2">
                                            <i className="fas fa-ticket-alt fa-4x text-primary" />
                                        </div> */}
                                            <h1 className="display-5 fw-bold mb-2">14+</h1>
                                            <p className="text-muted mb-0">Years of Experience</p>
                                        </div>
                                    </div>
                                    <div className="col-8 col-md-9">
                                        <div className="mb-5">
                                            <p className="text-primary h6 mb-3"><i className="fa fa-check-circle text-secondary me-2" />
                                                Customer Satisfaction</p>
                                            <p className="text-primary h6 mb-3"><i className="fa fa-check-circle text-secondary me-2" />
                                                Convenient Services</p>
                                            <p className="text-primary h6 mb-3"><i className="fa fa-check-circle text-secondary me-2" />
                                                Variety of Options</p>
                                            <p className="text-primary h6 mb-3"><i className="fa fa-check-circle text-secondary me-2" />
                                                Affordable Rates</p>
                                            <p className="text-primary h6 mb-3"><i className="fa fa-check-circle text-secondary me-2" />
                                                Reliable & Safe</p>
                                        </div>
                                        <div className="d-flex flex-wrap">
                                            <div id="phone-tada" className="d-flex align-items-center justify-content-center me-4">
                                                <a to className="position-relative wow tada" data-wow-delay=".9s">
                                                    <i className="fa fa-phone text-primary fa-3x" />
                                                    <div className="position-absolute" style={{ top: 0, left: 25 }}>
                                                        {/* <span><i className="fa fa-comment-dots text-secondary" /></span> */}
                                                    </div>
                                                </a>
                                            </div>
                                            <div className="d-flex flex-column justify-content-center">
                                                <span className="text-primary">Have any questions?</span>
                                                <span className="text-secondary fw-bold fs-5" style={{ letterSpacing: 2 }}>   <a href="tel:+91 7389578180"> +91 7389578180</a></span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-xl-5 wow fadeInLeft" data-wow-delay="0.1s">
                                <div className="bg-light rounded">
                                    {/* <img src="./assets/img/about-2.png" className="img-fluid w-100" style={{ marginBottom: '-7px' }} alt="Image" /> */}
                                    <img src="./assets/img/About the Shiv Travels.webp" className="img-fluid w-100 border-bottom " style={{ borderTopRightRadius: 300, borderTopLeftRadius: 300 }} alt="Image" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>



        </>
    )
}

export default HomeAbout